import { summarizeByKeyClass } from '../monitoring';
import type { KeyClass } from '../monitoring';
import type { Store } from './userStore';

/** Data keys of `Store` (methods excluded). */
type StoreDataKey = {
  [K in keyof Store]-?: Store[K] extends (...args: never[]) => unknown
    ? never
    : K;
}[keyof Store];

/** `user_store` snapshot allowlist, exhaustive over `StoreDataKey`: unlisted store keys are never sent. */
const KEY_CLASSES: Record<StoreDataKey, KeyClass> = {
  broker: 'value',
  status: 'value',
  gateway: 'value',
  displayName: 'value',
  amo: 'value',
  thirdPartyCookieSupported: 'value',
  useCommonGatewayDm: 'value',
  loanGateway: 'value',
  loanEnv: 'value',
  deviceType: 'value',
  featureBrokerList: 'count',
  recentBrokers: 'count',
  recentIntents: 'count',
  token: 'presence',
  CSRF: 'presence',
  smallcaseAuthToken: 'presence',
  userInfo: 'presence',
};

/** Sentry-safe `user_store` context snapshot of `store`. */
export function summarizeUserStore(store: Store) {
  return summarizeByKeyClass<StoreDataKey>(store, KEY_CLASSES);
}
